import request from '@/utils/request'

/**
 * 认证模块API
 */

// 发送验证码
export function sendVerificationCode(data) {
  return request({
    url: '/auth/send-verification-code',
    method: 'post',
    data
  })
}

// 用户注册
export function register(data) {
  return request({
    url: '/auth/register',
    method: 'post',
    data
  })
}

// 手机号密码登录
export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

// 验证码登录
export function loginByCode(data) {
  return request({
    url: '/auth/login-by-code',
    method: 'post',
    data
  })
}

// 刷新Token
export function refreshToken(data) {
  return request({
    url: '/auth/refresh-token',
    method: 'post',
    data
  })
}

// 微信登录
export function wechatLogin(data) {
  return request({
    url: '/auth/wechat-login',
    method: 'post',
    data
  })
}
